import { render, staticRenderFns } from "./InternalTraceSection.vue?vue&type=template&id=b6686d48&scoped=true"
import script from "./InternalTraceSection.vue?vue&type=script&lang=ts"
export * from "./InternalTraceSection.vue?vue&type=script&lang=ts"
import style0 from "./InternalTraceSection.vue?vue&type=style&index=0&id=b6686d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6686d48",
  null
  
)

export default component.exports